import React, { useEffect, useState } from "react";
import {
  Layout,
  Row,
  Col,
  Space,
  Button,
  Badge,
  Typography,
  Dropdown,
  Menu,
  Switch,
} from "antd";
import { Link } from "react-router-dom";
import HeaderPage from "../../pages/HeaderPage";
import DetectionLogo from "../../pages/DetectionLogo";
import AdminPanel from "../NavItems";
import { useAuth } from "../../Context/authContext";
import { clearCookie } from "../Common/Utils";
const { Header } = Layout;
const { Text } = Typography;

function Navbar() {
  const { activeButton, setActiveButton, user } = useAuth();
  const handleButtonClick = (buttonId) => {
    setActiveButton(buttonId);
  };

  return (
    <div style={{ padding: "30px" }}>
      <Header style={{ backgroundColor: "transparent", padding: 0 }}>
        <Row justify="space-between">
          <DetectionLogo />

          <Col className="header-typography">
            {/* <Space size={"large"}>
              <Link to="/upload">UPLOAD</Link>
              <Link to="/">SEARCH</Link>
              <Link to="/">HELLO, Vinoth Periyasamy</Link>
              <Link to="/">LOGOUT</Link>
            </Space> */}
            <div className="custom-header-menu">
              <Space size={"large"}>
                <Link
                  onClick={() => setActiveButton("upload")}
                  className={
                    activeButton === "upload" ? "active" : "non-active"
                  }
                  to="/"
                >
                  UPLOAD
                </Link>
                <Link
                  onClick={() => setActiveButton("search")}
                  className={
                    activeButton === "search" ? "active" : "non-active"
                  }
                  to="/search"
                >
                  SEARCH
                </Link>
                <span
                  className={activeButton === "Hello" ? "active" : "non-active"}
                >
                  HELLO,{" "}
                  {user && Object.keys(user).length > 0
                    ? user.given_name + " " + user.family_name
                    : ""}
                </span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    clearCookie("detection_auth");
                    localStorage.clear();
                    window.location.href = "/signin";
                  }}
                  className={
                    activeButton === "logout" ? "active" : "non-active"
                  }
                >
                  LOGOUT
                </span>
              </Space>
            </div>
          </Col>
        </Row>
      </Header>
    </div>
  );
}

export default Navbar;
